import { Collapse, TableCell, TableRow } from '@material-ui/core';
import 'moment/min/locales';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';
import swal from 'sweetalert2';
import Config from '../../commons/config/Config.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import Security from '../../commons/security/Security.js';
import Timezone from '../../commons/timezone/Timezone.js';
import { StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles';
import * as Constants from '../atributoDinamico/constants.js';
import LocaleFormat from '../../commons/utils/LocaleFormat.js';
import FormularioDetail from './FormularioDetail';
import FormularioPdf from './FormularioPdf.js';
import ValidacionGranularModal from './ValidacionGranularModal';
import MinimoVitalModal from './MinimoVitalModal';
import MinimoVitalHistorialModal from './MinimoVitalHistorialModal';
import MinimoVitalSeleccionEstadoModal from './MinimoVitalSeleccionEstadoModal';
import WarningIcon from '@material-ui/icons/Warning';

const FormulariosGridRow = (props) => {
  const columnsEnabled = props.columnsEnabled;
  const formulario = props.formulario;
  const baseUrl = props.baseUrl;
  const intl = useIntl();
  const [redirectTo, setRedirectTo] = useState(null);
  const [open, setOpen] = useState(false);
  const [isHidden, setIsHidden] = useState('hidden-personal');
  const [showValidacionGranular, setShowValidacionGranular] = useState(false);
  const [showMinimoVital, setShowMinimoVital] = useState(false);
  const [showHistorialMinimoVital, setShowHistorialMinimoVital] = useState(false);
  const [showSeleccionEstadoMovil, setShowSeleccionEstadoMovil] = useState(false);
  // VEC-3476: tiene_falla_minimo_vital es un flag histórico ("este checklist
  // tuvo una falla de mínimo vital al completarse") — no se oculta al
  // resolver, sigue mostrándose igual que si se recargara la página.
  // tiene_historial_minimo_vital en cambio sí se actualiza localmente porque
  // resolver garantiza que pasa a existir (nunca puede ir de true a false).
  const [tieneHistorialMinimoVitalOverride, setTieneHistorialMinimoVitalOverride] = useState(null);
  const tieneFallaMinimoVital = formulario.tiene_falla_minimo_vital;
  const tieneHistorialMinimoVital = tieneHistorialMinimoVitalOverride !== null ? tieneHistorialMinimoVitalOverride : formulario.tiene_historial_minimo_vital;
  const estadosTooltip = ['', 'CERRADO', 'PENDIENTE', 'SIN COMPROBACION', 'EN PROCESO'];
  const hasPermission = Security.hasPermission('CHECKLIST_VALIDAR_HISTORICO');
  const hasPermissionComentar = Security.hasPermission('CHECKLIST_COMENTAR');
  const validacionGranularHabilitada = ConfigBusiness.get('checklist.validacion.granular.habilitado') !== 'false';
  const [observacionesCambioEstado, setObservacionesCambioEstado] = useState(null);
  // VEC-3599: selección múltiple de checklists completos desde la grilla. Solo tiene
  // sentido con la validación granular habilitada — el flujo binario viejo decide un
  // checklist a la vez y no se extiende acá.
  const mostrarCheckboxSeleccionMasiva = hasPermission && validacionGranularHabilitada;


  useEffect(() => {
    getEstado();
  }, []);

  const getEstado = (estado) => {
    switch (estado) {
      case Constants.ID_ESTADO_APROBACION_VALIDO:
        return 'status-green';
        break;
      case Constants.ID_ESTADO_APROBACION_PENDIENTE:
        return 'status-yellow';
        break;
      case Constants.ID_ESTADO_APROBACION_INVALIDO:
        return 'status-red';
        break;
      case Constants.ID_ESTADO_APROBACION_SIN_COMPROBACION:
        return 'status-grey';
        break;
    }
  };

  // Función que cambia el estado "open" y el estado "isHidden" entre "hidden-personal" y "block".
  const toggleCollapse = () => {
    setOpen(!open); // Cambiar el estado "open" a su valor contrario.
    if (isHidden === 'hidden-personal') {
      setIsHidden('block'); // Cambiar el estado "isHidden" a "block" si estaba en "hidden-personal".
    } else {
      setIsHidden('hidden-personal'); // Cambiar el estado "isHidden" a "hidden-personal" si no estaba en "hidden-personal".
    }
  };

  // Función que maneja la confirmación y la solicitud a la API.
  const handleConfirmation = () => {
    if (observacionesCambioEstado === null) {
      // Mostrar el cuadro de diálogo de confirmación.
      swal({
        title: intl.formatMessage({ id: 'formulariosGridRow.validacion_checklist', defaultMessage: 'Validación de Checklist' }),
        text: intl.formatMessage({ id: 'formulariosGridRow.confirmar_validar_checklist', defaultMessage: '¿Confirma que desea validar el checklist?' }),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: intl.formatMessage({ id: 'formulariosGridRow.aceptar', defaultMessage: 'Aceptar' }),
        cancelButtonText: intl.formatMessage({ id: 'formulariosGridRow.cancelar', defaultMessage: 'Cancelar' }),
        ...(hasPermissionComentar ? {
          input: 'textarea',
          inputPlaceholder: intl.formatMessage({ id: 'formulariosGridRow.comentario_placeholder', defaultMessage: 'Agregar un comentario (opcional)...' }),
          inputAttributes: { maxlength: 2000 },
        } : {}),
      }).then((isConfirmed) => {
        if (isConfirmed.value !== undefined && isConfirmed.value !== false) {
          const comentario = hasPermissionComentar ? (isConfirmed.value || '') : '';
          // Realizar la solicitud a la API.
          fetch(Config.get('apiUrlBase') + '/formulario/' + formulario.id + '/validar', {
            method: 'POST',
            body: JSON.stringify({
              observacion_validacion: observacionesCambioEstado,
              comentario: comentario,
            }),
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'Authorization-Token': localStorage.getItem('token'),
            },
          })
            .then((response) => {
              if (response.status === 200) {
                swal({
                  title: intl.formatMessage({ id: 'formulariosGridRow.checklist_validado', defaultMessage: 'Checklist Validado' }),
                  confirmButtonText: intl.formatMessage({ id: 'formulariosGridRow.aceptar', defaultMessage: 'Aceptar' }),
                }).then(() => {
                  window.location.reload();
                });
              }
            })
            .catch((error) => {
              // Mostrar un mensaje de error con SweetAlert si la solicitud falla.
              swal('Error', 'Hubo un error al cerrar el checklist', 'error');
            });
        }
      });
    } else {
      // Redirigir a la página si ya hay observaciones.
      window.location.href = redirectTo;
    }
  };
  // Función que maneja la cancelación del checklist.
  const handleCancelChecklist = () => {
    let component = this;
    if (observacionesCambioEstado === null) {
      // Mostrar el cuadro de diálogo de confirmación.
      swal({
        title: intl.formatMessage({ id: 'formulariosGridRow.validacion_checklist', defaultMessage: 'Validación de Checklist' }),
        text: intl.formatMessage({ id: 'formulariosGridRow.confirmar_cancelar_checklist', defaultMessage: '¿Confirma que desea cancelar la validación?' }),
        showCancelButton: true,
        confirmButtonText: intl.formatMessage({ id: 'formulariosGridRow.aceptar', defaultMessage: 'Aceptar' }),
        cancelButtonText: intl.formatMessage({ id: 'formulariosGridRow.cancelar', defaultMessage: 'Cancelar' }),
      }).then((isConfirmed) => {
        if (isConfirmed.value === true) {
          // Realizar la solicitud a la API para cancelar.
          fetch(Config.get('apiUrlBase') + '/formulario/' + formulario.id + '/cancelar', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'Authorization-Token': localStorage.getItem('token'),
            },
          })
            .then((response) => {
              if (response.status === 200) {
                swal({
                  title: intl.formatMessage({ id: 'formulariosGridRow.checklist_cancelado', defaultMessage: 'Checklist Cancelado' }),
                  confirmButtonText: intl.formatMessage({ id: 'formulariosGridRow.aceptar', defaultMessage: 'Aceptar' }),
                }).then((isConfirmed) => {
                  if (isConfirmed.value === true) {
                    window.location.reload();
                  }
                });
              }
            })
            .catch((error) => {
              // Mostrar un mensaje de error con SweetAlert si la solicitud falla.
              swal('Error', 'Hubo un error al cancelar el checklist', 'error');
            });
        }
      });
    } else {
      // Redirigir a la página si ya hay observaciones.
      window.location.href = redirectTo;
    }
  };
  return (
    <>
      {redirectTo && <Redirect push to={redirectTo} />}
      <TableRow style={props.seleccionado ? { backgroundColor: '#EDEEFC' } : undefined}>
        <StyledTableCell>
          {mostrarCheckboxSeleccionMasiva &&
            <input
              type="checkbox"
              checked={!!props.seleccionado}
              onChange={() => props.onToggleSeleccion(formulario)}
            />
          }
        </StyledTableCell>
        <StyledTableCell>
          <div className="d-flex">
            <div onClick={() => toggleCollapse()}>
              {open ? (
                <i className="fa fa-2x fa-angle-double-down personal-no-focus avatar-plus-detail pointer"></i>
              ) : (
                <i className="fa fa-angle-double-right fa-2x personal-no-focus avatar-plus-detail pointer"></i>
              )}
            </div>
            <div className="text-center" style={{ minWidth: '50px' }}>
              <i className={'fa-2x ' + formulario.tipo_formulario.icono} />
            </div>
          </div>
        </StyledTableCell>
        <StyledTooltip title={estadosTooltip[formulario.estado]} arrow placement="right">
          <td
            align="left"
            className={getEstado(formulario.estado) + ' p-0 all custom-lineHeight br'}
            style={{ maxWidth: '3px' }}
          />
        </StyledTooltip>
        <StyledTableCell align="left">
          {formulario.id}
          {!!tieneFallaMinimoVital && (
            <StyledTooltip title={intl.formatMessage({ id: 'formulariosGridRow.tooltip_minimo_vital', defaultMessage: 'Contiene falla de mínimo vital — click para resolver' })}>
              <span
                style={{ marginLeft: '6px', color: '#FF9800', verticalAlign: 'middle', cursor: hasPermission ? 'pointer' : 'default' }}
                onClick={() => hasPermission && setShowMinimoVital(true)}
              >
                <WarningIcon fontSize="small" />
              </span>
            </StyledTooltip>
          )}
          {!!tieneHistorialMinimoVital && (
            <StyledTooltip title={intl.formatMessage({ id: 'formulariosGridRow.tooltip_historial_minimo_vital', defaultMessage: 'Ver historial de Mínimo Vital' })}>
              <span
                className="text-success"
                style={{ marginLeft: '6px', verticalAlign: 'middle', cursor: 'pointer' }}
                onClick={() => setShowHistorialMinimoVital(true)}
              >
                <i className="fa fa-history" style={{ verticalAlign: 'middle', position: 'relative', top: '-2px' }}></i>
              </span>
            </StyledTooltip>
          )}
          {showHistorialMinimoVital && (
            <MinimoVitalHistorialModal
              intl={intl}
              formularioId={formulario.id}
              onClose={() => setShowHistorialMinimoVital(false)}
            />
          )}
          {showMinimoVital && (
            <MinimoVitalModal
              intl={intl}
              formularioId={formulario.id}
              onClose={() => setShowMinimoVital(false)}
              onConcluido={(requiereSeleccionEstadoMovil) => {
                setShowMinimoVital(false);
                setTieneHistorialMinimoVitalOverride(true);
                if (requiereSeleccionEstadoMovil) {
                  setShowSeleccionEstadoMovil(true);
                }
              }}
            />
          )}
          {showSeleccionEstadoMovil && (
            <MinimoVitalSeleccionEstadoModal
              intl={intl}
              movilId={formulario.movil_id}
              formularioId={formulario.id}
              onClose={() => setShowSeleccionEstadoMovil(false)}
              onGuardado={() => setShowSeleccionEstadoMovil(false)}
            />
          )}
        </StyledTableCell>
        <StyledTableCell align="left">{formulario.tipo_formulario.nombre}</StyledTableCell>
        <StyledTableCell align="left">
          {formulario.created_at
            ? LocaleFormat.formatDateTime(Timezone.getDateForClient(formulario.created_at))
            : ''}
        </StyledTableCell>
        <StyledTableCell align="left">{formulario.entidad}</StyledTableCell>
        <StyledTableCell align="left">{formulario.movilUnidad || '-'}</StyledTableCell>
        <StyledTableCell align="left">{formulario.movilVin}</StyledTableCell>
        <StyledTableCell align="left">
          {formulario.usuario_modificacion ? formulario.usuario_modificacion.label : ''}
        </StyledTableCell>
        <StyledTableCell align="left">{formulario.fallas}</StyledTableCell>
        <StyledTableCell align="left">
          {formulario.base ? formulario.base.descripcion : ''}
        </StyledTableCell>
        {columnsEnabled.transportadora ?
          <StyledTableCell align="left">
            {formulario.transportadora}
          </StyledTableCell>
          : null
        }
        {columnsEnabled.rentadora ?
          <StyledTableCell align="left">
            {formulario.rentadora}
          </StyledTableCell>
          : null
        }
        <StyledTableCell align="left">
          {formulario.base ? formulario.base.sub_region_eloquent.nombre : ''}
        </StyledTableCell>
        <StyledTableCell align="left">
          {formulario.chofer ? formulario.chofer.fullName : ''}
        </StyledTableCell>
        <StyledTableCell>
          <div className="d-inline-flex">
            <button
              className="action view btn btn-sm btn-icon btn-dt-grid text-success"
              data-title="Ver"
              data-togle="tooltip"
              data-placement="top"
              onClick={() => setRedirectTo(baseUrl + '/' + formulario.id)}
            >
              <i className="fa fa-search fa-xs" />
            </button>
            <button
              className="action edit btn btn-sm btn-icon btn-dt-grid text-success"
              data-title="Editar"
              data-togle="tooltip"
              data-placement="top"
              onClick={() => setRedirectTo(baseUrl + '/' + formulario.id + '/edit')}
            >
              <i className="fa fa-pencil fa-xs" />
            </button>
            <FormularioPdf formulario_id={formulario.id} intl={intl} />
          </div>
          <div className="d-inline-flex">
            {hasPermission && (validacionGranularHabilitada || (
              formulario.estado === Constants.ID_ESTADO_APROBACION_INVALIDO ||
              formulario.estado === Constants.ID_ESTADO_APROBACION_SIN_COMPROBACION ||
              formulario.estado === Constants.ID_ESTADO_APROBACION_PENDIENTE
            )) && (
              <button
                className="action approve btn btn-sm btn-icon btn-dt-grid text-success"
                data-title="Validar Checklist"
                data-toggle="tooltip"
                data-placement="top"
                onClick={() => validacionGranularHabilitada ? setShowValidacionGranular(true) : handleConfirmation()}
              >
                <i className="fa fa-checklist fa-xs" />
                <i className="fas fa-check-circle fa-xs"></i>
              </button>
            )}
            {formulario.estado === Constants.ID_ESTADO_APROBACION_VALIDO && hasPermission && (
              <button
                className="btn btn-sm btn-icon btn-dt-grid text-secondary"
                data-title="Checklist Cerrado"
                data-toggle="tooltip"
                data-placement="top"
                onClick={handleCancelChecklist}
              >
                <i className="fa fa-lock fa-xs" />
              </button>
            )}
          </div>
          {showValidacionGranular && (
            <ValidacionGranularModal
              intl={intl}
              formularioId={formulario.id}
              onClose={() => setShowValidacionGranular(false)}
              onConcluido={(checklistCompletado) => {
                setShowValidacionGranular(false);
                // El candado del checklist puede haber cambiado (ver VEC-3362, punto 1):
                // mismo mecanismo que ya usa handleCancelChecklist para reflejarlo en la grilla.
                if (checklistCompletado) {
                  window.location.reload();
                }
              }}
            />
          )}
        </StyledTableCell>
      </TableRow>
      <TableRow className={isHidden}>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, background: 'rgb(244, 245, 250)' }}
          colSpan={20}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <FormularioDetail
              intl={intl}
              formulario_id={formulario.id}
              style={{ maxWidth: '85vw' }}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default FormulariosGridRow;
